<template>
  <div class="media-quote">
    <div class="media-quote-logos">
      <span
        class="media-quote-pos-prev"
        @click="prevCursor()"
      />
      <span
        :class="{'media-quote-logo': true, 'media-quote-logos-fade': cursor !== 0}"
        @click="switchCursor(0)"
      >
        <img
          class="small"
          src="@/assets/bias-mini-guitar/guitar_world_logo.png"
        >
      </span>
      <span
        :class="{'media-quote-logo': true, 'media-quote-logos-fade': cursor !== 1}"
        @click="switchCursor(1)"
      >
        <img
          class="small"
          src="@/assets/bias-mini-guitar/future_music_logo.png"
        >
      </span>
      <span
        :class="{'media-quote-logo': true, 'media-quote-logos-fade': cursor !== 2}"
        @click="switchCursor(2)"
      >
        <img
          class="small"
          src="@/assets/bias-mini-guitar/guitarguitar_logo.png"
        >
      </span>
      <span
        :class="{'media-quote-logo': true, 'media-quote-logos-fade': cursor !== 3}"
        @click="switchCursor(3)"
      >
        <img
          class="small"
          src="@/assets/bias-mini-guitar/guitar_interactive_logo.png"
        >
      </span>
      <span
        class="media-quote-pos-next"
        @click="nextCursor()"
      />
    </div>
    <div class="media-quote-quotes">
      <p :class="{'quote-text': 1, 'quote-text-unhide': cursor === 0}">
        “尤其适合于中小型演出和录音需要。”
      </p>
      <p
        :class="{'quote-text': 1, 'quote-text-unhide': cursor === 1}"
      >
        “是箱头和箱体模拟技术让 BIAS 系列产品拥有了如今的地位。”
      </p>
      <p
        :class="{'quote-text': 1, 'quote-text-unhide': cursor === 2}"
      >
        “无论何时写作、排练、录音和巡演都能随身携带精选的优秀音色已不再是梦想，它的优势就在于便携和方便！”
      </p>
      <p :class="{'quote-text': 1, 'quote-text-unhide': cursor === 3}">
        “就当前的技术而言，这真是令人难以置信的惊艳。”
        <br>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      cursor: 0,
      timer: null
    }
  },
  mounted: function () {
    this.timer = setInterval(() => {
      this.cursor += 1
      if (this.cursor === 4) {
        this.cursor = 1
      }
    }, 3000)
  },
  methods: {
    switchCursor (index) {
      this.cursor = index
      // console.log('switching to ', index)
      clearInterval(this.timer)
    },
    nextCursor () {
      if (this.cursor === 3) {
        return this.switchCursor(0)
      }
      this.switchCursor(this.cursor + 1)
    },
    prevCursor () {
      if (this.cursor === 0) {
        return this.switchCursor(3)
      }
      this.switchCursor(this.cursor - 1)
    }
  }
}
</script>

<style scoped lang="scss">
.media-quote {
  span > img {
    width: 130px;
  }
  &-pos-prev {
    display: block;
    transform: rotate(135deg);
    border-right: 10px solid;
    border-bottom: 10px solid;
    height: 30px;
    width: 30px;
    @media (max-width: 551px) {
      height: 20px;
      width: 20px;
      border-right: 5px solid;
      border-bottom: 5px solid;
    }
    @media screen and (min-width: 769px) {
      display: none;
    }
  }
  &-pos-next {
    display: block;
    transform: rotate(-45deg);
    border-right: 10px solid;
    border-bottom: 10px solid;
    height: 30px;
    width: 30px;
    @media (max-width: 551px) {
      height: 20px;
      width: 20px;
      border-right: 5px solid;
      border-bottom: 5px solid;
    }
    @media screen and (min-width: 769px) {
      display: none;
    }
  }
  &-logos {
    display: flex;
    justify-content: space-evenly;
    @media (max-width: 768px) {
      justify-content: space-between;
    }
    align-items: center;
    img {
      height: 50px;
      &.small {
        width: 130px;
        height: auto;
      }
      &.width-first {
        width: 200px;
        height: auto;
      }
      @media (max-width: 551px) {
        height: 32px;
      }
    }
    &-fade {
      filter: opacity(50%);
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
  width: 60%;
  margin: 0 auto;
  padding: 50px 0;
  height: 300px;

  @media (max-width: 768px) {
    width: 90%;
  }

  @media (max-width: 551px) {
    height: 170px;
    padding: 0;
  }

  &-quotes {
    margin-top: 50px;
    text-align: center;

    @media (max-width: 551px) {
      margin-top: 36px;
    }

    &-fade {
      display: none;
    }

    p.quote-text {
      margin: 0 auto;
      font-size: 24px;
      font-weight: 300;
      font-style: italic;
      color: #e2e2e2;
      @media (max-width: 551px) {
        font-size: 17px;
      }
      display: none;
      &-unhide {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bias-mini-guitar-media-quote.vue